/**
 * rafThrottle
 * ===========
 * Ensures `fn` runs at most once per animation frame, using only the
 * latest call's arguments - for event handlers (scroll/resize) that can
 * fire many times between frames.
 */
export const rafThrottle = (fn) => {
  let scheduled = false;
  let lastArgs = [];
  return (...args) => {
    lastArgs = args;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fn(...lastArgs);
    });
  };
};
